import { CURRENT_PLATFORM } from 'utils/constants';
import routes from './routes.json';

/**
 * @param {Array<String> | String} route
 * @param {{name: String}} platform
 * @returns {String}
 */

export const translateRoute = (route, platform = CURRENT_PLATFORM) => {
  if (Array.isArray(route)) {
    return route.map(subroute => translateRoute(subroute, platform)).join('');
  }
  if (typeof routes[route] === 'undefined') {
    throw new Error(
      `The route "${route}" defined in Router.jsx doesn't have translations`,
    );
  }

  return routes[route][platform.name];
};
